import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const ProfessionaBadmintonCoaching = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Professional Badminton Coaching</h2>
                            <p>
                                At Net Nest Badminton Sports Club, our Professional Badminton Coaching program is designed to provide high-quality, structured, and result-oriented training for players of all ages and skill levels. With experienced coaches, modern training methods, and a strong focus on individual development, we help players build confidence, consistency, and competitive excellence on the court.
                            </p>
                            <p>
                                <h2>Expert & Certified Coaches</h2>
                                Our coaching team consists of qualified and experienced badminton professionals who possess deep technical knowledge and practical match experience. They focus on understanding each player’s strengths, weaknesses, and goals, ensuring personalized guidance and continuous improvement. The coaches are dedicated to mentoring players with discipline, motivation, and professionalism.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Professional Badminton Coaching.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Structured & Systematic Training Approach</h2>
                            <p>
                                Our coaching follows a well-planned and progressive training structure. Sessions are designed to develop skills step by step, starting from strong fundamentals to advanced techniques. Training includes grip correction, footwork patterns, stroke development, shot placement, and tactical awareness, ensuring complete mastery of the game.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Focus on Technical Excellence</h2>
                            <p>
                                Technical accuracy is the foundation of our coaching philosophy. Players receive detailed training in all aspects of badminton, including clears, drops, smashes, net play, defense, and deception shots. Coaches provide constant feedback and correction to help players achieve precision, consistency, and control.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Physical Fitness & Conditioning</h2>
                            <p>
                                Badminton demands speed, agility, endurance, and strength. Our professional coaching integrates fitness and conditioning sessions to enhance overall athletic performance. These sessions include agility drills, speed training, stamina building, flexibility exercises, and injury-prevention techniques to keep players fit and match-ready.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Strength & Match Temperament</h2>
                            <p>
                                We strongly emphasize mental conditioning as a key part of professional coaching. Players are trained to handle pressure, stay focused during rallies, and maintain confidence in competitive situations. Match strategy, decision-making, and game awareness are developed through regular practice matches and guided analysis.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Individual Attention & Performance Monitoring</h2>
                            <p>
                                Every player at Net Nest receives personalized attention. Coaches regularly assess performance, track progress, and provide constructive feedback. Individual training plans are adjusted based on improvement levels, helping players overcome weaknesses and achieve their personal goals faster.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Competitive Exposure & Tournament Preparation</h2>
                            <p>
                                Our professional coaching program prepares players for competitive play through regular match practice, internal tournaments, and tournament-specific training. Players are guided on rules, scoring systems, match preparation, and recovery, ensuring they are fully prepared for competition.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Safe, Positive & Professional Training Environment</h2>
                            <p>
                                Net Nest Badminton Sports Club provides a safe, disciplined, and motivating environment that encourages learning and growth. We maintain high standards of professionalism, respect, and sportsmanship, helping players develop both on and off the court.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ProfessionaBadmintonCoaching;
